import React, { useEffect, useState } from "react";
import { Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import icon from "../../../Assets/Icons/badge.svg";
import nameIcon from "../../../Assets/Icons/name.svg";
import mailIcon from "../../../Assets/Icons/mail.svg";
import companyIcon from "../../../Assets/Icons/company.svg";
import phoneIcon from "../../../Assets/Icons/call.svg";
import homeIcon from "../../../Assets/Icons/home_pin.svg";
import securityIcon from "../../../Assets/Icons/security.svg";
import accountIcon from "../../../Assets/Icons/account.svg";
import "./style.css";
import { getUserProfile } from "../../../API/userProfile";
import { ClipLoader } from "react-spinners";

const Profile = () => {
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState({});

  const fetchUserProfileInfo = async () => {
    try {
      setLoading(true);

      const response = await getUserProfile();
      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data || {};
        setProfileData(data);
      } else {
        message.error(response?.message);
      }
    } catch (error) {
      message.error("Failed to fetch user profile data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfileInfo();
  }, []);

  const navigate = useNavigate();
  const handleChangePassword = () => {
    navigate("/change-password");
  };
  const handleEditProfile = () => {
    navigate("/edit-profile");
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="loader-container"
        >
          <ClipLoader size={50} color={"#123abc"} loading={loading} />
        </div>
      ) : (
        <div className="profile">
          <div className="header">
            <div className="header-wrapper">
              <div className="icon">
                <img src={icon} alt="info icon" className="info-icon" />
              </div>
              <div className="heading">Personal Information</div>
            </div>
            <div className="edit-btn">
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={handleEditProfile}
              >
                Edit Profile
              </Button>
            </div>
          </div>
          <div className="tabs">
            <div className="tab">
              <div className="icon">
                <img src={nameIcon} alt="name icon" className="name-icon" />
              </div>
              <div className="title">Full Name</div>
              <div className="value">{profileData?.name}</div>
            </div>
            <div className="tab">
              <div className="icon">
                <img src={mailIcon} alt="mail icon" className="mail-icon" />
              </div>
              <div className="title">Email Address</div>
              <div className="value">{profileData?.email}</div>
            </div>
            <div className="tab">
              <div className="icon">
                <img
                  src={companyIcon}
                  alt="company icon"
                  className="comp-icon"
                />
              </div>
              <div className="title">Company Name</div>
              <div className="value">{profileData?.company_name}</div>
            </div>
          </div>
          <div className="tabs">
            <div className="tab">
              <div className="icon">
                <img src={phoneIcon} alt="phone icon" className="phone-icon" />
              </div>
              <div className="title">Phone Number</div>
              <div className="value">{profileData?.phone_number}</div>
            </div>
            <div className="tab">
              <div className="icon">
                <img src={homeIcon} alt="home icon" className="phone-icon" />
              </div>
              <div className="title">Address</div>
              <div className="value">{profileData?.business_address}</div>
            </div>
          </div>
          <div className="security">
            <div className="header-wrapper">
              <div className="icon">
                <img src={securityIcon} alt="name icon" className="name-icon" />
              </div>
              <div className="heading">Security & Privacy</div>
            </div>
            <div className="security-section">
              <div className="section-header">
                <div className="header-wrapper">
                  <div className="icon">
                    <img
                      src={accountIcon}
                      alt="name icon"
                      className="name-icon"
                    />
                  </div>

                  <div>
                    <div className="section-title">Account Password</div>
                    <div className="description">
                      We recommend a unique password.
                    </div>
                  </div>
                </div>
                <Button className="password-btn" onClick={handleChangePassword}>
                  Change Password
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Profile;
